import { createContext } from "react";
import OrderSettingsPageStore from './store'

const store = new OrderSettingsPageStore();
const OrderSettingsPageStoreContext = createContext<OrderSettingsPageStore>(store);
export default OrderSettingsPageStoreContext;
